import WriteByStuArea from "@/pages/comp/plan/todo_dailyc/common/write_by_stu";

function WriteTodoDailyCByStuPopup(props: any) {
  let myProps = {
    closePopup:()=>{},
    callback_refresh:()=>{},
    callback_complete:()=>{},
    callback_delete_todoc:()=>{},
    select_date:"",
    subject_name:"",
    stu_seq_arr:[],
    sort:"complete",
    ...props
  };

  return (
    <div>
      <WriteByStuArea
        close_text="닫기"
        close_func={myProps.closePopup}
        callback_refresh={myProps.callback_refresh}
        callback_complete={myProps.callback_complete}
        callback_delete_todoc={myProps.callback_delete_todoc}
        select_date={myProps.select_date}
        subject_name={myProps.subject_name}
        stu_seq_arr={myProps.stu_seq_arr}
        sort={myProps.sort}
      ></WriteByStuArea>
    </div>
  );
};
export default WriteTodoDailyCByStuPopup;